import { tw } from 'twind';

import { usePdp } from 'hooks/usePdp';
import { Link } from 'ui/elements/Link';
import { buildProductUrl } from 'utils/buildProductUrl';

export const ProductFitOptions = () => {
  const { desiredSwatch, masterProduct } = usePdp();

  const selectedSwatch = masterProduct?.variations.find(
    item => item.colorValue === desiredSwatch
  );

  const hasAlternativeOrderableFitOptions = masterProduct?.fitOptions?.some(
    fitOption => {
      const isDifferentMasterProduct =
        fitOption.masterProduct.id !== masterProduct.id;

      return (
        isDifferentMasterProduct &&
        fitOption.masterProduct.variations.some(
          variation =>
            variation.orderable &&
            variation.colorValue === selectedSwatch?.colorValue
        )
      );
    }
  );

  if (
    !masterProduct?.fitOptions ||
    masterProduct.fitOptions.length < 2 ||
    !hasAlternativeOrderableFitOptions
  )
    return null;

  return (
    <div
      className="mb-4"
      data-test-id="fit-options-picker"
      aria-labelledby="fit-options-title"
    >
      <div className="flex flex-row flex-wrap gap-1">
        {masterProduct.fitOptions.map(fitOption => {
          const productUrl = buildProductUrl(
            fitOption.masterProduct.id,
            fitOption.masterProduct.name,
            { color: selectedSwatch?.colorValue || false }
          );
          const isCurrentFit = masterProduct.id === fitOption.masterProduct.id;
          return (
            <Link
              disabled={isCurrentFit}
              key={fitOption.masterProduct.id}
              dataTestId={`fit-option-${fitOption.masterProduct.id}`}
              className={tw(
                'relative border flex-none opacity-100 rounded-sm px-4 h-8 flex items-center justify-center',
                isCurrentFit && 'bg-puma-black border-puma-black text-white'
              )}
              variant="black"
              href={productUrl}
            >
              <span className="font-bold text-sm uppercase">
                {fitOption.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
